import { watch, nextTick } from 'vue';
import { useLayoutStore } from '@/stores/layoutStore';
import { storeToRefs } from 'pinia';
import { waitForDomToRepaint } from '@/utils/waitForDomToRepaint';
import { wait } from '@/utils/wait';

let waitForChartComponentToBeMountedPromise: Promise<void> | undefined = undefined;

export async function waitForChartComponentToBeMounted(): Promise<void> {
  const layoutStore = useLayoutStore();

  if (waitForChartComponentToBeMountedPromise)
    return await waitForChartComponentToBeMountedPromise;

  const { isChartComponentMounted } = storeToRefs(layoutStore);

  waitForChartComponentToBeMountedPromise = new Promise((resolve) => {
    async function resolvePromiseIfChartComponentIsMounted() {
      if (!isChartComponentMounted.value)
        return;

      removeIsChartComponentMountedWatcher();

      await waitForDomToRepaint();
      await nextTick();
      await wait(0);

      resolve();
    }

    const removeIsChartComponentMountedWatcher = watch(isChartComponentMounted, resolvePromiseIfChartComponentIsMounted);

    resolvePromiseIfChartComponentIsMounted();
  });

  return await waitForChartComponentToBeMountedPromise;
}
